<template>
  <div>
    <div class="main-center">
      <v-button class="" type="info" name="" @click="showModel"
        >物模型TSL</v-button
      >
      <!-- <v-button class="" type="primary" name="" @click="showAddModel"
        >添加自定义功能</v-button
      > -->
      <v-button class="" type="primary" name="" @click="showDraftModel"
        >前往编辑草稿</v-button
      >
    </div>
    <vxe-table
      row-id="id"
      :data="infoData"
      align="left"
      :sort-config="{
        defaultSort: { field: 'function_typeView', order: 'asc' },
      }"
    >
      <vxe-table-column
        field="name"
        show-overflow
        min-width="80"
        title="功能名称"
      ></vxe-table-column>
      <!-- <vxe-table-column
        sortable
        field="function_typeView"
        show-overflow
        min-width="80"
        title="功能类型"
      ></vxe-table-column> -->
      <vxe-column title="功能类型" field="function_typeView" sortable show-overflow min-width="80">
        <template v-slot="slotProps">
          <span v-if="slotProps.row.function_typeView === '事件'" class="text-success" >{{slotProps.row.function_typeView}}</span>
          <span v-if="slotProps.row.function_typeView === '属性'" class="text-error" >{{slotProps.row.function_typeView}}</span>
          <span v-if="slotProps.row.function_typeView === '服务'" class="text-warn" >{{slotProps.row.function_typeView}}</span>
        </template>
      </vxe-column>
      <vxe-table-column
        field="identifier"
        show-overflow
        min-width="100"
        title="功能唯一标识"
      ></vxe-table-column>
      <vxe-table-column
        field="data_type"
        show-overflow
        min-width="80"
        title="数据类型"
      ></vxe-table-column>
      <vxe-column
        field="model_type"
        show-overflow
        min-width="80"
        title="物模型类型"
      >
        <template v-slot="slotProps">
          <span v-if="slotProps.row.model_type === 'COMMON'" class="text-success" >公共物模型</span>
          <span v-if="slotProps.row.model_type === 'PRODUCT'" class="text-warn" >产品物模型</span>
        </template>
      </vxe-column>
      <vxe-table-column
        field="desc"
        show-overflow
        min-width="280"
        title="备注"
      ></vxe-table-column>
      <vxe-column title="操作" min-width="140">
        <template v-slot="slotProps">
          <span class="handle-button"
            ><v-button
              size="S"
              type="text"
              name="btn2"
              slot="reference"
              @click="openViewModel(slotProps.row, 2)"
              >查看</v-button
            ></span
          >
        </template>
      </vxe-column>
    </vxe-table>
    <v-pagination
      v-if="total"
      @change-page="changePage"
      @change-size="changeSize"
      :total="total"
      name="page-basic"
      is-show-total
      is-change-size
      is-input-page
      :current-page="this.currentPage"
    ></v-pagination>

    <UpdataAndview
      :showInputDialog.sync="UpdataAndviewloading"
      ref="UpdataAndview"
      :updataOrview="updataOrview"
      :id="id"
      :functiontype="functiontype"
      @getData="getData"
    ></UpdataAndview>
    <Model
      :showInputDialog.sync="Modelloading"
      ref="Model"
      :productKey="productKey"
    ></Model>
  </div>
</template>

<script>
import UpdataAndview from "@/components/product/physicalmodel/updataAndview-physicalmodel.vue";
import Model from "@/components/product/physicalmodel/model.vue";
import { FUNCTION_TYPE } from "@/common/libs/Contains";
export default {
  components: {  UpdataAndview, Model },
  props: {
    productName: {},
    productId: {},
    productKey: {},
  },
  data() {
    return {
      table: [],
      UpdataAndviewloading: false,
      Modelloading: false,
      updataOrview: 1, //1为编辑 2为查看
      id: 0,
      functiontype: "",
      infoData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
    };
  },
  created() {
    this.getData();
  },

  methods: {
    async getData() {
      const subData = {
        product_id: Number(this.productId),
        product_key: this.productKey,
        page_num: this.currentPage,
        page_size: this.pageSize,
      };
      const res = await this.$post(
        "/td/td-iot-api/iot/thing/page/v1",
        subData,
        false
      );
      if (res.code === 0) {
        this.infoData = res.data.list;
        this.total = res.data.page.total;
        this.infoData.map((item) => {
          item.function_typeView = FUNCTION_TYPE[item.function_type];
        });
      } else {
        if (res.code == "100410") {
          setTimeout(() => {
            this.getData();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    changePage(page) {
      this.currentPage = Number(page);
      this.getData();
    },
    changeSize(size) {
      this.pageSize = Number(size);
      this.currentPage = 1
      this.getData();
    },
    openViewModel(row, isUpdata) {
      this.updataOrview = isUpdata;
      this.id = row.ID;
      this.functiontype = row.function_type;
      this.UpdataAndviewloading = !this.UpdataAndviewloading;
    },
    showModel() {
      this.Modelloading = !this.Modelloading;
    },
    showDraftModel() {
      this.$router.push({name: '/deviceInfo-manage/product-draft-list', query: {productKey: this.productKey, productName: this.productName, productId: this.productId}})
    }
  },
  beforeDestroy() {},
};
</script>

<style lang="scss"></style>
